export default {
  watch: {
    '$route.hash': function () {
      this.refreshModal();
      this.$spinner.hide();
    },
  },
  mounted() {
    this.refreshModal();
  },
  methods: {
    displayModal(mode) {
      this.$router.replace({ hash: `#${mode}` });
    },
    refreshModal() {
      if (this.$route.hash) {
        this.toggleModal(this.$route.hash.replace('#', ''));
      }
    },
    hideModal() {
      if (this.$route.hash) {
        this.$router.replace({ hash: '' });
      }
    },
  },
};
